import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from './pages/HomePage';
import BrowseProductsPage from './pages/BrowseProducts';
import PartnerPage from './pages/Partner';
import ContactPage from './pages/Contact';
import AboutPage from './pages/About';
import HowPage from './pages/How';
import ProductPage from "./pages/ProductPage";
import CartPage from "./features/cart/CartPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";
import SuccessPage from "./pages/SuccessPage";
import NotifyPage from "./pages/Notify";
import FeedbackPage from "./pages/FeedbackPage";
import SubscribePage from "./pages/Subscribe";
import NotFoundPage from "./pages/NotFound";

import { initAnalytics } from "./features/analytics/tracker";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/browse-products" element={<BrowseProductsPage />} />
          <Route path="/partner" element={<PartnerPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/how-it-works" element={<HowPage />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/notify" element={<NotifyPage />} />
          <Route path="/subscribe" element={<SubscribePage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
